import React, { Fragment, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ResetPassword, Send } from "../constant";
import API from "../services/API";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const ForgetPwd = () => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!email) {
      toast.error("Please enter your email address.", { autoClose: 4000 });
      return;
    }

    setLoading(true);

    try {
      const res = await API.post("/schoolStaff/forgotPassword", { email });

      if (res?.data?.response_code === 1000) {
        toast.success("Temporary password has been sent to your email.", {
          autoClose: 4000,
        });

        setTimeout(() => navigate("/"), 2000);
      } else {
        toast.error(res?.data?.message || "Unable to reset password.", {
          autoClose: 5000,
        });
      }
    } catch (err) {
      toast.error(
        err?.response?.data?.message ||
          "Unable to contact the server. Please try again.",
        { autoClose: 5000 }
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <Fragment>
      <style>{`
        :root {
          --spgov-blue-950: #061a3a;
          --spgov-blue-900: #08245c;
          --spgov-blue-800: #0b357a;
          --spgov-blue-700: #0f4ea8;
          --spgov-blue-600: #1368d8;
          --spgov-blue-500: #2585ff;
          --spgov-blue-100: #e8f2ff;
          --spgov-blue-50: #f4f9ff;
          --spgov-border: #dbeafe;
          --spgov-text: #0f172a;
          --spgov-muted: #64748b;
        }

        .spgov-reset-screen {
          min-height: 100vh;
          display: grid;
          grid-template-columns: 0.95fr 1.05fr;
          background:
            radial-gradient(circle at top left, rgba(37, 133, 255, 0.12), transparent 34%),
            linear-gradient(135deg, #f8fbff 0%, #eef6ff 48%, #f8fafc 100%);
          font-family: Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
        }

        .spgov-reset-info {
          position: relative;
          overflow: hidden;
          padding: 64px;
          color: #ffffff;
          background:
            radial-gradient(circle at 16% 14%, rgba(56, 189, 248, 0.26), transparent 28%),
            radial-gradient(circle at 88% 88%, rgba(37, 133, 255, 0.34), transparent 34%),
            linear-gradient(135deg, #061a3a 0%, #08245c 44%, #0f4ea8 100%);
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          isolation: isolate;
        }

        .spgov-reset-info:before {
          content: "";
          position: absolute;
          width: 620px;
          height: 620px;
          border-radius: 999px;
          right: -240px;
          bottom: -240px;
          background: radial-gradient(circle, rgba(255,255,255,0.16), transparent 60%);
          z-index: -1;
        }

        .spgov-reset-info:after {
          content: "";
          position: absolute;
          inset: 0;
          background-image:
            linear-gradient(rgba(255,255,255,0.045) 1px, transparent 1px),
            linear-gradient(90deg, rgba(255,255,255,0.045) 1px, transparent 1px);
          background-size: 44px 44px;
          mask-image: linear-gradient(to bottom, rgba(0,0,0,0.65), transparent 85%);
          z-index: -1;
        }

        .spgov-brand-mark {
          width: 78px;
          height: 78px;
          border-radius: 26px;
          display: grid;
          place-items: center;
          margin-bottom: 20px;
          background: rgba(255,255,255,0.12);
          border: 1px solid rgba(255,255,255,0.24);
          box-shadow: 0 24px 60px rgba(0,0,0,0.22);
          backdrop-filter: blur(14px);
        }

        .spgov-brand-mark span {
          width: 48px;
          height: 48px;
          border-radius: 17px;
          display: grid;
          place-items: center;
          color: #ffffff;
          font-size: 20px;
          font-weight: 950;
          letter-spacing: -0.08em;
          background: linear-gradient(135deg, #38bdf8, #2585ff);
          box-shadow: 0 16px 34px rgba(37,133,255,0.35);
        }

        .spgov-pill {
          display: inline-flex;
          align-items: center;
          gap: 9px;
          padding: 9px 15px;
          border-radius: 999px;
          background: rgba(255,255,255,0.13);
          border: 1px solid rgba(255,255,255,0.22);
          color: rgba(255,255,255,0.92);
          font-size: 12px;
          font-weight: 850;
          letter-spacing: .08em;
          text-transform: uppercase;
          backdrop-filter: blur(14px);
        }

        .spgov-pill:before {
          content: "";
          width: 8px;
          height: 8px;
          border-radius: 999px;
          background: #38bdf8;
          box-shadow: 0 0 0 5px rgba(56,189,248,0.16);
        }

        .spgov-reset-copy h1 {
          max-width: 620px;
          margin: 0;
          font-size: clamp(42px, 4.8vw, 62px);
          line-height: 0.96;
          font-weight: 950;
          letter-spacing: -0.06em;
        }

        .spgov-reset-copy p {
          max-width: 540px;
          margin-top: 22px;
          font-size: 17px;
          line-height: 1.7;
          color: rgba(255,255,255,0.78);
        }

        .spgov-reset-meta {
          display: grid;
          grid-template-columns: repeat(3, 1fr);
          gap: 14px;
          max-width: 590px;
        }

        .spgov-meta-card {
          padding: 18px;
          border-radius: 24px;
          background: rgba(255,255,255,0.12);
          border: 1px solid rgba(255,255,255,0.18);
          backdrop-filter: blur(14px);
          box-shadow: 0 20px 50px rgba(0,0,0,0.10);
        }

        .spgov-meta-card strong {
          display: block;
          font-size: 22px;
          font-weight: 950;
          letter-spacing: -0.035em;
        }

        .spgov-meta-card span {
          display: block;
          margin-top: 4px;
          font-size: 12px;
          font-weight: 750;
          color: rgba(255,255,255,0.72);
        }

        .spgov-reset-form-wrap {
          min-height: 100vh;
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 48px;
          background:
            radial-gradient(circle at top right, rgba(37,133,255,0.14), transparent 34%),
            radial-gradient(circle at bottom left, rgba(56,189,248,0.10), transparent 28%),
            #f8fbff;
        }

        .spgov-reset-card {
          width: 100%;
          max-width: 460px;
          padding: 36px;
          border-radius: 32px;
          background: rgba(255,255,255,0.9);
          border: 1px solid rgba(219,234,254,0.95);
          box-shadow:
            0 30px 90px rgba(8,36,92,0.14),
            inset 0 1px 0 rgba(255,255,255,0.75);
          backdrop-filter: blur(18px);
        }

        .spgov-mobile-mark {
          display: none;
          width: 70px;
          height: 70px;
          margin: 0 auto 22px;
          border-radius: 24px;
          place-items: center;
          background: linear-gradient(135deg, #08245c, #1368d8);
          box-shadow: 0 20px 44px rgba(19,104,216,0.28);
        }

        .spgov-mobile-mark span {
          color: #ffffff;
          font-size: 20px;
          font-weight: 950;
          letter-spacing: -0.08em;
        }

        .spgov-reset-eyebrow {
          display: inline-flex;
          align-items: center;
          gap: 8px;
          margin-bottom: 14px;
          padding: 8px 12px;
          border-radius: 999px;
          background: #e8f2ff;
          color: #0f4ea8;
          font-size: 11px;
          font-weight: 900;
          letter-spacing: .08em;
          text-transform: uppercase;
        }

        .spgov-reset-eyebrow:before {
          content: "";
          width: 7px;
          height: 7px;
          border-radius: 999px;
          background: #2585ff;
        }

        .spgov-reset-card h2 {
          margin: 0;
          color: #061a3a;
          font-size: 31px;
          font-weight: 950;
          letter-spacing: -0.045em;
        }

        .spgov-reset-card .subtitle {
          margin-top: 9px;
          margin-bottom: 28px;
          color: #64748b;
          font-size: 14px;
          line-height: 1.6;
        }

        .spgov-field {
          margin-bottom: 18px;
        }

        .spgov-field label {
          display: block;
          margin-bottom: 8px;
          color: #1e3a5f;
          font-size: 13px;
          font-weight: 850;
        }

        .spgov-field input {
          width: 100%;
          height: 54px;
          padding: 0 16px;
          border-radius: 17px;
          border: 1px solid #dbeafe;
          background: rgba(255,255,255,0.96);
          color: #0f172a;
          font-size: 14px;
          outline: none;
          transition: 0.18s ease;
          box-shadow: 0 1px 0 rgba(15,23,42,0.02);
        }

        .spgov-field input::placeholder {
          color: #94a3b8;
        }

        .spgov-field input:focus {
          border-color: #2585ff;
          box-shadow:
            0 0 0 4px rgba(37,133,255,0.12),
            0 10px 24px rgba(37,133,255,0.08);
        }

        .spgov-reset-action {
          width: 100%;
          height: 56px;
          margin-top: 6px;
          border: none;
          border-radius: 18px;
          color: #ffffff;
          font-size: 14px;
          font-weight: 950;
          letter-spacing: .045em;
          background: linear-gradient(135deg, #08245c 0%, #0f4ea8 45%, #2585ff 100%);
          box-shadow: 0 18px 34px rgba(19,104,216,0.28);
          cursor: pointer;
          transition: 0.18s ease;
        }

        .spgov-reset-action:hover {
          transform: translateY(-1px);
          box-shadow: 0 22px 42px rgba(19,104,216,0.34);
        }

        .spgov-reset-action:disabled {
          opacity: 0.72;
          cursor: not-allowed;
          transform: none;
        }

        .spgov-back-row {
          margin-top: 16px;
          text-align: right;
        }

        .spgov-back-row button {
          border: none;
          background: transparent;
          color: #0f4ea8;
          font-size: 13px;
          font-weight: 850;
          cursor: pointer;
          padding: 4px 0;
        }

        .spgov-back-row button:hover {
          color: #2585ff;
          text-decoration: underline;
          text-underline-offset: 3px;
        }

        .spgov-reset-note {
          margin-top: 24px;
          padding: 15px;
          border-radius: 20px;
          background: linear-gradient(135deg, #e8f2ff, #f4f9ff);
          border: 1px solid #dbeafe;
          color: #0b357a;
          font-size: 12px;
          font-weight: 750;
          line-height: 1.55;
        }

        .spgov-reset-note strong {
          display: block;
          margin-bottom: 3px;
          color: #061a3a;
          font-size: 12px;
          font-weight: 950;
        }

        @media (max-width: 992px) {
          .spgov-reset-screen {
            grid-template-columns: 1fr;
          }

          .spgov-reset-info {
            display: none;
          }

          .spgov-reset-form-wrap {
            padding: 24px;
          }

          .spgov-mobile-mark {
            display: grid;
          }

          .spgov-reset-card {
            padding: 28px;
            border-radius: 28px;
          }
        }

        @media (max-width: 420px) {
          .spgov-reset-form-wrap {
            padding: 16px;
            align-items: flex-start;
            padding-top: 34px;
          }

          .spgov-reset-card {
            padding: 24px;
          }

          .spgov-reset-card h2 {
            font-size: 27px;
          }

          .spgov-field input,
          .spgov-reset-action {
            height: 52px;
          }
        }
      `}</style>

      <div className="spgov-reset-screen">
        <section className="spgov-reset-info">
          <div>
            <div className="spgov-brand-mark" aria-label="SPGO.my">
              <span>SP</span>
            </div>
            <div className="spgov-pill">SPGO.my Government Portal</div>
          </div>

          <div className="spgov-reset-copy">
            <h1>Account Recovery</h1>
            <p>
              Request a temporary password to regain access to the SPGO.my
              administration portal.
            </p>
          </div>

          <div className="spgov-reset-meta">
            <div className="spgov-meta-card">
              <strong>Secure</strong>
              <span>Authorised access</span>
            </div>
            <div className="spgov-meta-card">
              <strong>Verified</strong>
              <span>Email recovery</span>
            </div>
            <div className="spgov-meta-card">
              <strong>Portal</strong>
              <span>Restricted system</span>
            </div>
          </div>
        </section>

        <section className="spgov-reset-form-wrap">
          <div className="spgov-reset-card">
            <div className="spgov-mobile-mark" aria-label="SPGO.my">
              <span>SP</span>
            </div>

            <div className="spgov-reset-eyebrow">Official Access Portal</div>

            <h2>{ResetPassword || "Reset Password"}</h2>
            <p className="subtitle">
              Enter your registered email address. If the account exists, a
              temporary password will be sent to your inbox.
            </p>

            <form onSubmit={handleSubmit}>
              <div className="spgov-field">
                <label htmlFor="email">Email Address</label>
                <input
                  id="email"
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="name@agency.gov.my"
                  autoComplete="email"
                  required
                />
              </div>

              <button
                className="spgov-reset-action"
                type="submit"
                disabled={loading}
              >
                {loading ? "SENDING..." : Send || "SEND RESET EMAIL"}
              </button>
            </form>

            <div className="spgov-back-row">
              <button type="button" onClick={() => navigate("/")}>
                Back to sign in
              </button>
            </div>

            <div className="spgov-reset-note">
              <strong>Restricted System</strong>
              Password recovery is available for authorised SPGO.my personnel
              only. All requests may be logged for security purposes.
            </div>
          </div>
        </section>

        <ToastContainer
          theme="colored"
          position="top-right"
          autoClose={4000}
          newestOnTop
          closeOnClick
          pauseOnHover
          draggable
        />
      </div>
    </Fragment>
  );
};

export default ForgetPwd;